import React from 'react';
import { partesContacto } from '../utils/contactos';

const TablaOngs = ({ 
    ongs, 
    onRowDoubleClick, 
    currentPage = 1, 
    itemsPerPage = 10, 
    totalItems = 0,
    onPageChange = () => {},
    onItemsPerPageChange = () => {}
}) => {
    console.log("ong---->", ongs)
    // Calcular número total de páginas
    const totalPages = Math.ceil(totalItems / itemsPerPage) || 1;
    
    // Generar array de números de página para la paginación
    const getPageNumbers = () => {
        const pages = [];
        const maxVisiblePages = 5;
        
        if (totalPages <= maxVisiblePages) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
            let endPage = startPage + maxVisiblePages - 1;
            
            if (endPage > totalPages) {
                endPage = totalPages;
                startPage = Math.max(1, endPage - maxVisiblePages + 1);
            }
            
            if (startPage > 1) {
                pages.push(1);
                if (startPage > 2) pages.push('...');
            }
            
            for (let i = startPage; i <= endPage; i++) {
                pages.push(i);
            }
            
            if (endPage < totalPages) {
                if (endPage < totalPages - 1) pages.push('...');
                pages.push(totalPages);
            }
        }
        
        return pages;
    };

    const pageNumbers = getPageNumbers();
    const startItem = (currentPage - 1) * itemsPerPage + 1;
    const endItem = Math.min(currentPage * itemsPerPage, totalItems);

    if (!ongs || ongs.length === 0) {
        return (
            <div className="text-center py-4 text-gray-500">
                No hay ONGs para mostrar
            </div>
        );
    }

    return (
        <div className="flex flex-col space-y-4">
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg w-full">
                <div className="inline-block min-w-full align-middle">
                    <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-gray-200">
                            <thead className="bg-gray-50">
                                <tr>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Código
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Nombre
                                    </th>                                    
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Partido
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Categoría
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Resolución
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Contactos
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        LPO
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                                {ongs.map((ong) => (
                                    <tr 
                                        key={ong.id} 
                                        onDoubleClick={() => onRowDoubleClick(ong)}
                                        className="hover:bg-gray-50 cursor-pointer"
                                    >
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {ong.codigo}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 truncate max-w-xs" title={ong.nombre}>
                                            {ong.nombre}
                                        </td>                                        
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                            {ong.partido_nombre || ong.partidosede}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                            {ong.categoria}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                            {ong.resolucion}
                                        </td>
                                        <td className="px-6 py-4 text-sm text-gray-500">
                                            {/* Los contactos vienen de contactos_proyecto (catalogo
                                                por ONG). Antes se mostraba ongs.contacto, que la
                                                migracion 061 vacio, asi que la columna quedaba
                                                siempre en blanco. */}
                                            {(ong.contactos?.length > 0) ? (
                                                <ul className="space-y-1">
                                                    {ong.contactos.map(c => {
                                                        const { nombre, canales } = partesContacto(c);
                                                        return (
                                                            <li key={c.contacto_id}>
                                                                {/* El nombre y los canales van en lineas
                                                                    distintas y con distinto peso: pegados
                                                                    con un guion, un email parece parte
                                                                    del nombre de la persona. */}
                                                                {nombre ? (
                                                                    <span className="block text-gray-900">{nombre}</span>
                                                                ) : (
                                                                    <span className="block text-gray-900">Sin nombre</span>
                                                                )}
                                                                {canales.map((canal, i) => (
                                                                    <span key={i} className="block text-xs text-gray-500">
                                                                        {canal}
                                                                    </span>
                                                                ))}
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                            ) : (
                                                <span className="italic text-gray-400">Sin contactos</span>
                                            )}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                            {ong.lpo}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            
            {/* Controles de paginación */}
            <div className="flex flex-col sm:flex-row items-center justify-between px-4 py-3 bg-white border-t border-gray-200 sm:px-6">
                {/* Mostrar cantidad de items por página */}
                <div className="mb-2 sm:mb-0">
                    <div className="flex items-center">
                        <label htmlFor="itemsPerPage" className="text-sm text-gray-600 mr-2">
                            Mostrar:
                        </label>
                        <select
                            id="itemsPerPage"
                            value={itemsPerPage}
                            onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
                            className="mt-1 block w-full pl-3 pr-10 py-1 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
                        >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={50}>50</option>
                        </select>
                        <span className="ml-2 text-sm text-gray-600">registros</span>
                    </div>
                </div>
                
                {/* Contador de registros */}
                <div className="text-sm text-gray-600 mb-2 sm:mb-0">
                    Mostrando {startItem} a {endItem} de {totalItems} registros
                </div>
                
                {/* Navegación de páginas */}
                <div className="flex items-center space-x-1">
                    <button
                        onClick={() => onPageChange(1)}
                        disabled={currentPage === 1}
                        className="px-3 py-1 rounded border disabled:opacity-50"
                        aria-label="Primera página"
                    >
                        «
                    </button>
                    <button
                        onClick={() => onPageChange(Math.max(1, currentPage - 1))}
                        disabled={currentPage === 1}
                        className="px-3 py-1 rounded border disabled:opacity-50"
                        aria-label="Página anterior"
                    >
                        ‹
                    </button>
                    
                    {pageNumbers.map((number, index) => (
                        typeof number === 'number' ? (
                            <button
                                key={number}
                                onClick={() => onPageChange(number)}
                                className={`px-3 py-1 rounded border ${
                                    currentPage === number 
                                        ? 'bg-blue-500 text-white border-blue-500' 
                                        : 'hover:bg-gray-100'
                                }`}
                                aria-current={currentPage === number ? 'page' : undefined}
                            >
                                {number}
                            </button>
                        ) : (
                            <span key={`ellipsis-${index}`} className="px-2">
                                {number}
                            </span>
                        )
                    ))}
                    
                    <button
                        onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
                        disabled={currentPage === totalPages}
                        className="px-3 py-1 rounded border disabled:opacity-50"
                        aria-label="Siguiente página"
                    >
                        ›
                    </button>
                    <button
                        onClick={() => onPageChange(totalPages)}
                        disabled={currentPage === totalPages}
                        className="px-3 py-1 rounded border disabled:opacity-50"
                        aria-label="Última página"
                    >
                        »
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TablaOngs;
